import { GroupServiceInterface } from 'domain/services';
import {
  AddPersonToGroupUseCaseInterface,
  AddPlaceToGroupUseCaseInterface,
  GetAllArchivedGroupsUseCaseInterface,
  GetAllGroupsNotPaginatedUseCaseInterface,
  GetAllGroupsUserUseCaseInterface,
  GetAllPersonsFromGroupUseCaseInterface,
  GetAllPlacesFromGroupUseCaseInterface,
  GetGroupByIdUseCaseInterface,
  GetGroupListUseCaseInterface,
  ImportPersonsFromAnotherGroupUseCaseInterface,
  ImportPlacesFromAnotherGroupUseCaseInterface,
  RemovePersonFromGroupUseCaseInterface,
  RemovePlaceFromGroupUseCaseInterface,
} from 'domain/usecases';

export class GroupService implements GroupServiceInterface {
  constructor(
    private readonly _getAllGroupsUserUseCase: GetAllGroupsUserUseCaseInterface,
    private readonly _getGroupListUseCase: GetGroupListUseCaseInterface,
    private readonly _getAllGroupsNotPaginated: GetAllGroupsNotPaginatedUseCaseInterface,
    private readonly _getGroupById: GetGroupByIdUseCaseInterface,
    private readonly _getAllArchivedGroupsUseCase: GetAllArchivedGroupsUseCaseInterface,
    private readonly _addPersonToGroupUseCase: AddPersonToGroupUseCaseInterface,
    private readonly _removePersonFromGroupUseCase: RemovePersonFromGroupUseCaseInterface,
    private readonly _addPlaceToGroupUseCase: AddPlaceToGroupUseCaseInterface,
    private readonly _removePlaceFromGroupUseCase: RemovePlaceFromGroupUseCaseInterface,
    private readonly _getAllPersonsFromGroupUseCase: GetAllPersonsFromGroupUseCaseInterface,
    private readonly _getAllPlacesFromGroupUseCase: GetAllPlacesFromGroupUseCaseInterface,
    private readonly _importPersonsFromAnotherGroupUseCase: ImportPersonsFromAnotherGroupUseCaseInterface,
    private readonly _importPlacesFromAnotherGroupUseCase: ImportPlacesFromAnotherGroupUseCaseInterface,
  ) {}

  async getAllGroupsUser(
    params: GetAllGroupsUserUseCaseInterface.Params,
  ): Promise<GetAllGroupsUserUseCaseInterface.Result> {
    return await this._getAllGroupsUserUseCase.execute(params);
  }

  async getGroupList(
    params: GetGroupListUseCaseInterface.Params,
  ): Promise<GetGroupListUseCaseInterface.Result> {
    return await this._getGroupListUseCase.execute(params);
  }

  async getAllGroupsNotPaginated(
    params: GetAllGroupsNotPaginatedUseCaseInterface.Params,
  ): Promise<GetAllGroupsNotPaginatedUseCaseInterface.Result> {
    return await this._getAllGroupsNotPaginated.execute(params);
  }

  async getGroupById(
    params: GetGroupByIdUseCaseInterface.Params,
  ): Promise<GetGroupByIdUseCaseInterface.Result> {
    return await this._getGroupById.execute(params);
  }

  async getAllArchivedGroups(
    params: GetAllArchivedGroupsUseCaseInterface.Params,
  ): Promise<GetAllArchivedGroupsUseCaseInterface.Result> {
    return await this._getAllArchivedGroupsUseCase.execute(params);
  }

  async addPersonToGroup(
    params: AddPersonToGroupUseCaseInterface.Params,
  ): Promise<AddPersonToGroupUseCaseInterface.Result> {
    return await this._addPersonToGroupUseCase.execute(params);
  }

  async removePersonFromGroup(
    params: RemovePersonFromGroupUseCaseInterface.Params,
  ): Promise<RemovePersonFromGroupUseCaseInterface.Result> {
    return await this._removePersonFromGroupUseCase.execute(params);
  }

  async addPlaceToGroup(
    params: AddPlaceToGroupUseCaseInterface.Params,
  ): Promise<AddPlaceToGroupUseCaseInterface.Result> {
    return await this._addPlaceToGroupUseCase.execute(params);
  }

  async removePlaceFromGroup(
    params: RemovePlaceFromGroupUseCaseInterface.Params,
  ): Promise<RemovePlaceFromGroupUseCaseInterface.Result> {
    return await this._removePlaceFromGroupUseCase.execute(params);
  }

  async getAllPersonsFromGroup(
    params: GetAllPersonsFromGroupUseCaseInterface.Params,
  ): Promise<GetAllPersonsFromGroupUseCaseInterface.Result> {
    return await this._getAllPersonsFromGroupUseCase.execute(params);
  }

  async getAllPlacesFromGroup(
    params: GetAllPlacesFromGroupUseCaseInterface.Params,
  ): Promise<GetAllPlacesFromGroupUseCaseInterface.Result> {
    return await this._getAllPlacesFromGroupUseCase.execute(params);
  }

  async importPersonsFromAnotherGroup(
    params: ImportPersonsFromAnotherGroupUseCaseInterface.Params,
  ): Promise<ImportPersonsFromAnotherGroupUseCaseInterface.Result> {
    return await this._importPersonsFromAnotherGroupUseCase.execute(params);
  }

  async importPlacesFromAnotherGroup(
    params: ImportPlacesFromAnotherGroupUseCaseInterface.Params,
  ): Promise<ImportPlacesFromAnotherGroupUseCaseInterface.Result> {
    return await this._importPlacesFromAnotherGroupUseCase.execute(params);
  }
}
